import { render, staticRenderFns } from "./reelFacebook.vue?vue&type=template&id=40d41869"
import script from "./reelFacebook.vue?vue&type=script&lang=js"
export * from "./reelFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d41869')) {
      api.createRecord('40d41869', component.options)
    } else {
      api.reload('40d41869', component.options)
    }
    module.hot.accept("./reelFacebook.vue?vue&type=template&id=40d41869", function () {
      api.rerender('40d41869', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/reelFacebook.vue"
export default component.exports